import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";

function ClientesTable({
  id,
  clientes,
  loading,
  handleSelectCliente,
  isMantenedor,
  handleEditCliente,
  header,
  globalFilterFields,
  filters,
}) {
  const clientesComputed = Array.isArray(clientes)
    ? clientes.map((cliente) => ({
        ...cliente,
        direccion:
          cliente.domicilios.length > 0
            ? cliente.domicilios
                .map(
                  (d) =>
                    `${d.direccion ? d.direccion : "Sin Dirección"} - ${
                      d.comuna ? d.comuna : "Sin Comuna"
                    }`
                )
                .join(" | ")
            : "Sin Dirección",
        RLegal:
          cliente.representantes.length > 0
            ? cliente.representantes.map((r) => r.nombre).join(" | ")
            : "No tiene representante",
      }))
    : [];

  return (
    <div className="col-12">
      <DataTable
        header={header ? header : `Se encontraron ${clientes.length} clientes`}
        value={clientesComputed}
        className="p-datatable-gridlines"
        showGridlines
        paginator
        rows={10}
        rowsPerPageOptions={[10, 12, 20, 50, 100]}
        onRowClick={(e) => {
          if (isMantenedor) {
            handleEditCliente && handleEditCliente(e.data);
          } else {
            handleSelectCliente && handleSelectCliente(e.data);
          }
        }}
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown CurrentPageReport"
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} clientes"
        dataKey="id"
        loading={loading}
        emptyMessage="No se encontraron clientes."
        stripedRows="true"
        id={id}
        globalFilterFields={globalFilterFields}
        filters={filters}
        tableStyle={{ tableLayout: "fixed", width: "100%", minWidth: "1000px" }}
        scrollable
        scrollHeight="57vh"
        reorderableColumns
        resizableColumns
        columnResizeMode="fit"
      >
        <Column
          field="rut"
          header="RUT"
          style={{ minWidth: "7rem" }}
          sortable
        />
        <Column
          field="razon_social"
          header="Razón Social"
          style={{ minWidth: "7rem" }}
          sortable
        />
        <Column
          field="RLegal"
          header="Representante Legal"
          style={{ minWidth: "7rem" }}
          sortable
        />
        <Column
          field="direccion"
          header="Dirección"
          style={{ minWidth: "7rem" }}
          sortable
        />
        <Column
          header="Alias"
          field="alias"
          sortable
          style={{ minWidth: "7rem" }}
          body={(rowData) => (rowData.alias ? rowData.alias : "Sin alias")}
        />

        <Column
          header="Acción"
          style={{ width: "12rem" }}
          body={(rowData) =>
            isMantenedor === true ? (
              <>
                <Button
                  icon="pi pi-pencil"
                  className="p-button-rounded p-button-success p-button mr-2 mb-2 mt-2"
                  onClick={(e) => { e.stopPropagation(); handleEditCliente(rowData); }}
                  disabled={rowData.activo === false}
                  tooltip={"Editar Cliente"}
                  label="Editar"
                  outlined
                />
              </>
            ) : (
              <>
                <Button
                  icon="pi pi-plus"
                  className="p-button-rounded p-button-success p-button mr-2 mb-2 mt-2"
                  onClick={(e) => { e.stopPropagation(); handleSelectCliente(rowData); }}
                  disabled={rowData.activo === false}
                  label="Seleccionar"
                  outlined
                />
              </>
            )
          }
        />
      </DataTable>
    </div>
  );
};

export default ClientesTable;
